import * as types from '../state-constants/stateConstants';
import { shuffledArray } from '../helpers/shuffleArray';
import initState from '../state-store/initState';

const rootReducer = (state = {}, action) => {
  switch (action.type) {
    case types.ON_LOAD:
      return { ...state, loading: action.payload };
    case types.HIDE_MODAL:
      return { ...state, showWarning: false };
    case types.ON_NAV_TOGGLE:
      return {
        ...state,
        nav: {
          ...state.nav,
          open: action.payload,
        },
      };
    case types.ON_ROUTE_CHANGE:
      return {
        ...state,
        nav: {
          ...state.nav,
          open: false,
        },
      };
    case types.ON_CHANGE_GAME_DOWN:
      return {
        ...state,
        saved: {
          ...state.saved,
          gameLevel: state.saved.gameLevel - 1,
        },
      };
    case types.ON_CHANGE_GAME_UP:
      return {
        ...state,
        saved: {
          ...state.saved,
          gameLevel: state.saved.gameLevel + 1,
        },
      };
    case types.ON_TRIGGER_GAME:
      return {
        ...state,
        game: {
          ...state.game,
          time: state.gameData[action.payload].time,
        },
        saved: {
          ...state.saved,
          level: action.payload,
        },
        viewing: 'game',
      };
    case types.ON_START_GAME:
      return {
        ...state,
        game: {
          ...state.game,
          started: action.payload,
          timeOut: false,
          restarted: false,
        },
      };
    case types.ON_NEXT_GAME:
      return {
        ...state,
        viewing: 'selector',
        saved: {
          ...state.saved,
          gameLevel: state.saved.gameLevel + 1,
        },
        game: {
          ...initState.game,
        },
        shuffledBlockOrder: shuffledArray(state.settings.numOfBlocks),
      };
    case types.ON_RESTART_GAME:
      return {
        ...state,
        game: {
          ...initState.game,
          time: state.gameData[state.saved.level].time,
          restarted: true,
        },
        saved: {
          ...state.saved,
          level: state.saved.level,
        },
        shuffledBlockOrder: shuffledArray(state.settings.numOfBlocks),
      };
    case types.ON_COUNT_DOWN:
      return {
        ...state,
        game: {
          ...state.game,
          time: action.payload,
        },
      };
    case types.ON_COUNT_UP:
      return {
        ...state,
        game: {
          ...state.game,
          timeTaken: action.payload,
        },
      };
    case types.ON_STOP_GAME:
      return {
        ...state,
        game: {
          ...state.game,
          started: false,
          timeOut: action.payload,
        },
      };
    case types.ON_CANCEL_GAME:
      return {
        ...state,
        viewing: action.payload,
        game: {
          ...initState.game,
        },
        shuffledBlockOrder: shuffledArray(state.settings.numOfBlocks),
      };
    case types.ON_BLOCKS_MOUNTED:
      return { ...state, blocksMounted: action.payload };
    case types.ON_BLOCK_SELECTED:
      return { ...state, blockSelected: action.payload };
    case types.ON_BLOCK_TARGETED:
      return { ...state, blockTargeted: action.payload };
    case types.BLOCK_TRANSITION:
      return { ...state, changeStart: action.payload };
    case types.ON_CHANGE_BLOCK_ORDER:
      return {
        ...state,
        shuffledBlockOrder: action.payload,
        blockSelected: {},
        blockTargeted: {},
        game: {
          ...state.game,
          moveCount: state.game.moveCount + 1,
        },
      };
    case types.ON_CORRECT_BLOCK_ORDER:
      return {
        ...state,
        game: {
          ...state.game,
          roundWin: action.payload,
          started: false,
          timeOut: true,
        },
        saved: {
          ...state.saved,
          unlockedLevels: state.saved.gameLevel + 1,
        },
      };
    case types.SAVE_GAME_RESULTS:
      return {
        ...state,
        saved: {
          ...state.saved,
          best: state.saved.best.map((data, index) => {
            if (index === state.saved.level) {
              return action.payload;
            }
            return data;
          }),
        },
      };
    default:
      return state;
  }
};

export default rootReducer;



// WEBPACK FOOTER //
// ./src/state-reducers/rootReducer.js